const Translations = {};

Translations.load = async (lang)=>{
    if (!lang) lang = localStorage.getItem("language") || "fr";
    localStorage.setItem("language",lang);

    console.log("Loading translations for " + lang);
    let path = "_data/translations/" + lang + ".json?v=" + Date.now();

    try{
        let response = await fetch(path);
        let json = await response.json();
        Object.assign(Translations,json);
    }catch(e){
        console.error("Error loading translations",e);
    }
}
export default Translations;

